import script from "./AssetBreakdownAnalysis.vue?vue&type=script&setup=true&lang=js"
export * from "./AssetBreakdownAnalysis.vue?vue&type=script&setup=true&lang=js"

import "./AssetBreakdownAnalysis.vue?vue&type=style&index=0&id=516ff6f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-516ff6f4"]])

export default __exports__